var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2804_139)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.15 23.4263C43.5633 15.3763 36.4933 9.33301 28 9.33301C21.2567 9.33301 15.4 13.1597 12.4833 18.7597C5.46 19.5063 0 25.4563 0 32.6663C0 40.3897 6.27667 46.6663 14 46.6663H44.3333C50.7733 46.6663 56 41.4397 56 34.9997C56 28.8397 51.2167 23.8463 45.15 23.4263ZM32.6667 30.333V39.6663H23.3333V30.333H16.3333L28 18.6663L39.6667 30.333H32.6667Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2804_139"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.cfbc9caf93d603a93c8d7b4dcdd77838.svg";
export { ForwardRef as ReactComponent };